import { UserWithProfile, CurrentUser } from '@uplift/api';

export const findParty = ({ me, patient, provider }: { me: CurrentUser; patient?: UserWithProfile; provider?: UserWithProfile }) => {
  if (me.id === patient?.user.id) {
    return provider;
  }

  return patient;
};
